import type { HeartRateEvent } from '@model/DeviceConfiguration';
import {
  eventToRelativeSecond,
  getSessionTrackOriginTimestamp,
} from '../../../shared/hr-data';

export const buildSessionValueMap = (
  events: HeartRateEvent[],
  readValue: (event: HeartRateEvent) => number | undefined
): Map<number, number> => {
  const sorted = [...events].sort((a, b) => a.timestamp - b.timestamp);
  if (sorted.length === 0) return new Map();

  const originTimestamp = getSessionTrackOriginTimestamp(sorted);
  if (originTimestamp == null) return new Map();

  const grouped = new Map<number, number[]>();

  sorted.forEach(event => {
    const value = readValue(event);
    if (typeof value !== 'number' || !Number.isFinite(value)) return;

    const second = eventToRelativeSecond(event.timestamp, originTimestamp);
    const bucket = grouped.get(second) ?? [];
    bucket.push(value);
    grouped.set(second, bucket);
  });

  return new Map(
    [...grouped.entries()].map(([second, values]) => [
      second,
      values.reduce((sum, current) => sum + current, 0) / values.length,
    ])
  );
};
